import styled, { keyframes, css } from "styled-components";
import { COLORS } from "../../common/colors";

const popIn = keyframes`
  from { opacity: 0; transform: scale(0.5) translateY(16px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
`;

const popOut = keyframes`
  from { opacity: 1; transform: scale(1) translateY(0); }
  to   { opacity: 0; transform: scale(0.5) translateY(16px); }
`;

const glow = keyframes`
  0%, 100% { box-shadow: 0 4px 18px ${COLORS.primaryGlow}, 0 0 0 0 ${COLORS.primaryTint}; }
  50%       { box-shadow: 0 4px 18px ${COLORS.primaryGlow}, 0 0 0 8px rgba(61,107,94,0); }
`;

export const ScrollBtn = styled.button`
  position: fixed;
  right: 20px;
  bottom: 24px;
  z-index: 190;

  width: 46px;
  height: 46px;
  border-radius: 14px;
  border: none;
  padding: 0;

  background: linear-gradient(135deg, ${COLORS.primaryDark}, ${COLORS.primary});
  color: #ffffff;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  box-shadow:
    0 4px 18px ${COLORS.primaryGlow},
    0 1px 4px rgba(0,0,0,0.10),
    inset 0 1px 0 rgba(255,255,255,0.15);

  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};

  animation: ${({ $visible }) =>
    $visible
      ? css`${popIn} 0.32s cubic-bezier(0.34, 1.56, 0.64, 1) both`
      : css`${popOut} 0.22s ease both`};

  ${({ $visible, $pulsed }) =>
    $visible && !$pulsed &&
    css`animation: ${popIn} 0.32s cubic-bezier(0.34,1.56,0.64,1) both, ${glow} 2s ease 0.4s 2;`}

  transition: transform 0.2s ease, box-shadow 0.2s ease;

  svg {
    width: 20px;
    height: 20px;
    transition: transform 0.2s;
  }

  &:hover {
    transform: translateY(-4px) scale(1.08);
    box-shadow:
      0 10px 30px ${COLORS.primaryGlow},
      0 2px 8px rgba(0,0,0,0.12),
      inset 0 1px 0 rgba(255,255,255,0.20);
    svg { transform: translateY(-2px); }
  }

  &:active { transform: translateY(0) scale(0.96); }

  &:focus-visible {
    outline: 2px solid ${COLORS.accent};
    outline-offset: 3px;
  }

  @media (max-width: 48em) {
    right: 14px;
    bottom: 18px;
    width: 42px;
    height: 42px;
    border-radius: 12px;
  }
`;